var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgMap = function SvgSvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.307 2.838a1.5 1.5 0 0 0-1.114 0L8.807 5.393a1.5 1.5 0 0 1-1.114 0L1.779 3.027a.75.75 0 0 0-1.029.7V18.1a1.5 1.5 0 0 0 .943 1.393l6 2.4a1.5 1.5 0 0 0 1.114 0l6.386-2.555a1.5 1.5 0 0 1 1.114 0l5.914 2.362a.75.75 0 0 0 1.029-.7V6.631a1.5 1.5 0 0 0-.943-1.393zM8.25 5.5V22M15.75 2.731v16.5"
  })));
};
export default SvgSvgMap;